import { render, staticRenderFns } from "./DynamicAttributesTable.vue?vue&type=template&id=922bfcbc"
import script from "./DynamicAttributesTable.vue?vue&type=script&lang=js"
export * from "./DynamicAttributesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports